<h5>{{role.name}}</h5>
@for (reportTile of allReportTiles; track reportTile.id) {
  <div>
    <p-checkbox
      [(ngModel)]="selectedReports"
      [name]="role.name + '-group'"
      [value]="reportTile.id"
      (onChange)="modelChange($event, role.id, reportTile.id)"
    ></p-checkbox>
    <label for="reportTile">{{ reportTile.companyWide ? 'CW ' + reportTile.name: reportTile.name }} </label>
  </div>
}